import { MiscType } from './misc-data.type';
import { selectedSender, setSendersListPageDetails } from './misc-data.action';


const INITIAL_STATE = {
    orderId: "",
    phone: "",
    amount: "",
    transactionId: "",
    transactionTimeStamp: "",
    otpVal: "",
    orderServiceResponse: "",
    firstname: "",
    otpRefNo: "",
    campaigns: "",
    deviceInfo: "",
    userRegisterData: "",
    completeOrderId: "",
    txnLoader: "",
    uploadFile: [],
    activeLinkStatus: '',
    transferTotalAmount: '',
    surcharge: '',
    token: '',
    agentInfo: '',
    addsenderRequest: Object,
    addsenderRequestUrl: '',
    benefisciaryList: '',
    benefisciaryRequest: '',
    benefisciaryRequestUrl: '',
    stateList: [],
    cityList: [],
    branchList: [],
    ifscCode: '',
    senderListDetails: [],
    senderListPageDetails: [],
    totalSenders: '',
    selectedBankName: '',
    selectedBankId: '',
    selectedBankDetails: '',
    generateOtpResponse: '',
    branchAddress: '',
    selectSender: '',
    beneSubDetails: '',
    benefisciaryInfo: '',
    activeStatus: '',
    loginTime: Date,
    txmAmnt: '',
    txnSurchrg: '',
    txnTotalAmnt: '',
    moneyTransferProgress: '',
    createOrderStatusResponse: '',
    txnHistoryResponse: [],
    customerLimit: '',
    selecetdBenefisciaries: [],
    exportData: '',
    totalElementsNo: 0,
    txnPaginationResponse: '',
    bankLogoListTxt: '',
    senderCustomerId: '',
    beneCustomerId: '',
    graphResponse: '',

    partner: '',
    clientRequesterId: '',
    logoName: '',
    clientRole: '',
    taLoadPermission: '',


    toDate: '',
    formDate: '',
    callBackUrl: '',
    claimResp: '',

    retailerBalanceShow: '',
    claimLoadShow: '',
    retailerBalanceValue: 0,
    graphMonth: '3',

    timeoutModal: '',
    savedOtpDetails: '',
    errMsg: '',
    resetPasswordLoader: '',
    billPayShow: '',
    rechargeShow: '',
    aepsShow: '',
    dmtShow: '',
    payoutShow: '',
    kycShow: ''

};

const miscReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MiscType.setOrderId:
            return {
                ...state,
                orderId: action.payload,
            };

        case MiscType.setPhone:
            return {
                ...state,
                phone: action.payload,
            };
        case MiscType.setAmount:
            return {
                ...state,
                amount: action.payload,
            };
        case MiscType.setMoneyTransferTotalAmount:
            return {
                ...state,
                transferTotalAmount: action.payload,
            };
        case MiscType.setTransactionId:
            return {
                ...state,
                transactionId: action.payload,
            };


        case MiscType.setUserFirstName:
            return {
                ...state,
                firstname: action.payload,
            };
        case MiscType.setOtpRefNo:
            return {
                ...state,
                otpRefNo: action.payload,
            };


        case MiscType.setDeviceInfo:
            return {
                ...state,
                deviceInfo: action.payload,
            };

        case MiscType.setToken:
            return {
                ...state,
                token: action.payload,
            };
        case MiscType.setAgentInfo:
            return {
                ...state,
                agentInfo: action.payload,
            };


        case MiscType.setAddSenderRequest:
            return {
                ...state,
                addsenderRequest: action.payload,
            };
        case MiscType.setAddSenderRequestUrl:
            return {
                ...state,
                addsenderRequestUrl: action.payload,
            };

        case MiscType.setBenefisciaryList:
            return {
                ...state,
                benefisciaryList: action.payload,
            };
        case MiscType.setAddBenefisciaryRequest:
            return {
                ...state,
                benefisciaryRequest: action.payload,
            };
        case MiscType.setAddBenefisciaryRequestUrl:
            return {
                ...state,
                benefisciaryRequestUrl: action.payload,
            };

        case MiscType.setStateDetails:
            return {
                ...state,
                stateList: action.payload,
            };

        case MiscType.setCityList:
            return {
                ...state,
                cityList: action.payload,
            };
        case MiscType.setBranchList:
            return {
                ...state,
                branchList: action.payload,
            };
        case MiscType.setIfscCode:
            return {
                ...state,
                ifscCode: action.payload,
            };
        case MiscType.setSendersListDetails:
            return {
                ...state,
                senderListDetails: action.payload,
            };

        case MiscType.setMoneyTransferSurChargeAmount:
            return {
                ...state,
                surcharge: action.payload,
            };

        case MiscType.setBankDetails:
            return {
                ...state,
                bankDetails: action.payload,
            };

        case MiscType.setSelectedBankName:
            return {
                ...state,
                selectedBankName: action.payload,
            };

        case MiscType.setSelectedBankId:
            return {
                ...state,
                selectedBankId: action.payload,
            };

        case MiscType.setSelecetedBankDetails:
            return {
                ...state,
                selectedBankDetails: action.payload,
            };


        case MiscType.setOtpResponse:
            return {
                ...state,
                generateOtpResponse: action.payload,
            };



        case MiscType.setBranchAddress:
            return {
                ...state,
                branchAddress: action.payload,
            };


        case MiscType.selectedSender:
            return {
                ...state,
                selectSender: action.payload,
            };

        case MiscType.setBeneSubDetails:
            return {
                ...state,
                beneSubDetails: action.payload,
            };

        case MiscType.setCreteOrderReq:
            return {
                ...state,
                createOrderReq: action.payload,
            };

        case MiscType.setCreateOrderRes:
            return {
                ...state,
                createOrderRes: action.payload,
            };
        case MiscType.setBeneMoneyTransfer:
            return {
                ...state,
                benefisciaryInfo: action.payload,
            };


        case MiscType.setActiveStatus:
            return {
                ...state,
                activeStatus: action.payload,
            };

        case MiscType.setLogOutWarningStatus:
            return {
                ...state,
                logOutWarningStatus: action.payload,
            };

        case MiscType.setLoginTimestamp:
            return {
                ...state,
                loginTime: action.payload,
            };

        case MiscType.setTxnAmount:
            return {
                ...state,
                txmAmnt: action.payload,
            };

        case MiscType.setTxnsurcharge:
            return {
                ...state,
                txnSurchrg: action.payload,
            };

        case MiscType.setTxntotalAmount:
            return {
                ...state,
                txnTotalAmnt: action.payload,
            };

        case MiscType.setMoneyTransferProgress:
            return {
                ...state,
                moneyTransferProgress: action.payload,
            };

        case MiscType.setStatusEnqResponse:
            return {
                ...state,
                createOrderStatusResponse: action.payload,
            };


        case MiscType.setTxnHistoryResponse:
            return {
                ...state,
                txnHistoryResponse: action.payload,
            };


        case MiscType.setCustomerLimit:
            return {
                ...state,
                customerLimit: action.payload,
            };

        case MiscType.selectedBeneList:
            return {
                ...state,
                selecetdBenefisciaries: action.payload,
            };

        case MiscType.setTxnReportingData:
            return {
                ...state,
                exportData: action.payload,
            };

        case MiscType.setTxnHistoryElementNo:
            return {
                ...state,
                totalElementsNo: action.payload,
            };

        case MiscType.setTxnHistoryPaginationResponse:
            return {
                ...state,
                txnPaginationResponse: action.payload,
            };

        case MiscType.setTotalSenders:
            return {
                ...state,
                totalSenders: action.payload,
            };

        case MiscType.setSendersListPageDetails:
            return {
                ...state,
                senderListPageDetails: action.payload,
            };

        case MiscType.setBankLogoList:
            return {
                ...state,
                bankLogoListTxt: action.payload,
            };

        case MiscType.setSenderCustomerId:
            return {
                ...state,
                senderCustomerId: action.payload,
            };

        case MiscType.setBeneCustomerId:
            return {
                ...state,
                beneCustomerId: action.payload,
            };

        case MiscType.setGraphResponse:
            return {
                ...state,
                graphResponse: action.payload,
            };
        case MiscType.setOtpForBeneVerification:
            return {
                ...state,
                beneVerifyOtp: action.payload,
            };
        case MiscType.setBeneRegister:
            return {
                ...state,
                beneRegisterResponse: action.payload,
            };

        case MiscType.setPartner:
            return {
                ...state,
                partner: action.payload,
            };
        case MiscType.setRequesterId:
            return {
                ...state,
                clientRequesterId: action.payload,
            };
        case MiscType.setLogoName:
            return {
                ...state,
                logoName: action.payload,
            };
        case MiscType.setClientRole:
            return {
                ...state,
                clientRole: action.payload,
            };
        case MiscType.setTaLoadPermission:
            return {
                ...state,
                taLoadPermission: action.payload,
            };

        case MiscType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case MiscType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };
        case MiscType.setMiscCallBackUrl:
            return {
                ...state,
                callBackUrl: action.payload,
            };
        case MiscType.setClaimResp:
            return {
                ...state,
                claimResp: action.payload,
            };

        case MiscType.setRetailerBlanceShow:
            return {
                ...state,
                retailerBalanceShow: action.payload,
            };
        case MiscType.setClaimLoadShow:
            return {
                ...state,
                claimLoadShow: action.payload,
            };

        case MiscType.setRetailerBalanceVal:
            return {
                ...state,
                setRetailerBlanceShow: action.payload,
            };
        case MiscType.setDashboardPageGraphMonth:
            return {
                ...state,
                graphMonth: action.payload,
            };
        case MiscType.setTimeoutModal:
            return {
                ...state,
                timeoutModal: action.payload,
            };

        case MiscType.setBillPayShow:
            return {
                ...state,
                billPayShow: action.payload,
            };
        case MiscType.setRechargeShow:
            return {
                ...state,
                rechargeShow: action.payload,
            };
        case MiscType.setPayoutShow:
            return {
                ...state,
                payoutShow: action.payload,
            };
        case MiscType.setAepsShow:
            return {
                ...state,
                aepsShow: action.payload,
            };

        case MiscType.setDMTShow:
            return {
                ...state,
                dmtShow: action.payload,
            };
        case MiscType.setKycShow:
            return {
                ...state,
                kycShow: action.payload,
            };
        case MiscType.setSavedOtpDetails:
            return {
                ...state,
                savedOtpDetails: action.payload,
            };
        case MiscType.setErrMsg:
            return {
                ...state,
                errMsg: action.payload,
            };
        case MiscType.setResetPasswordLoader:
            return {
                ...state,
                resetPasswordLoader: action.payload,
            };
        case MiscType.setMenuVal:
            return {
                ...state,
                menuVal: action.payload,
            };

        case MiscType.RESET:
            return INITIAL_STATE;
        default:
            return state;
    }

};

export default miscReducer; 